/**
 * 获取 localStorage
 * @param {string} key 键
 * @return {Object}
 */
export const getStorage = key => {
  let data = localStorage.getItem(key)
  return data ? JSON.parse(data) : null
}
/**
 * 设置 localStorage
 * @param {string} key 键
 * @param {Object} value 值
 */
export const setStorage = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value))
}
/**
 * 移除 localStorage
 * @param {string} key 键
 */
export const removeStorage = key => {
  localStorage.removeItem(key)
}
/**
 * 清空 localStorage
 */
export const clearStorage = () => {
  localStorage.clear()
}

export const setSession = (key, value) => {
  session.setItem(key, JSON.stringify(value))
}
/**
 * 获取 sessionStorage
 * @param {string} key 键
 * @return {Object}
 */
export const getSession = key => {
  return JSON.parse(session.getItem(key)) || null
}
/**
 * 移除 sessionStorage
 * @param {string} key 键
 */
export const removeSession = key => {
  session.removeItem(key)
}
